import { render, staticRenderFns } from "./ExistingCollectionBookingDialog.vue?vue&type=template&id=047e7044&scoped=true"
import script from "./ExistingCollectionBookingDialog.vue?vue&type=script&lang=js"
export * from "./ExistingCollectionBookingDialog.vue?vue&type=script&lang=js"
import style0 from "./ExistingCollectionBookingDialog.vue?vue&type=style&index=0&id=047e7044&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e7044",
  null
  
)

export default component.exports